import { render, staticRenderFns } from "./ImportMemo.vue?vue&type=template&id=1c23be5b&lang=html"
import script from "./ImportMemo.vue?vue&type=script&lang=js"
export * from "./ImportMemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports